/*
 * Copyright 2012 Sagarana Tech.  All rigths reserved.
 *
 * This software is the confidential and proprietary information of
 * Sagarana Tech ("Confidential Information"). You shall not disclose such
 * Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with Sagarana Tech.
 *
 */

/**
 * Cancela o Stop
 *
 * @author Mozart Diniz mozartdiniz@sagaranatech.com
 * DATE: 22/03/2013
 */


Greenmile.Stop = Greenmile.Stop || {};

Greenmile.Stop.Cancel = function ({
  parentSelector = '#RouteSummary',
  successCallback
} = {}) {

    Greenmile.Stop.Base.call(this);

    this.createCancelCode = function() {
        this.cancelCode = new Monet.UI.Fields.PickList();
        this.cancelCode.setEntity("CancelCode");
        this.cancelCode.setLookUpEntity("CancelCode");
        this.cancelCode.setDisplayKey("description");

        this.cancelCode.setCustomFilter({
            criteriaChain:[
              {
                and:[
                  {
                    attr: "enabled",
                    eq: true
                  }
                ]
              }
            ]
          }
        );
        this.cancelCode.setCustomCriteria('{"filters":["id", "description"]}');

        this.cancelCode.render();
        this.cancelCode.setTextLabel(Monet.I18n.getResourcesByKey('Greenmile.Stop.Cancel.cancelCodesList'));
        this.cancelCode.setInputName("cancelCodes");
        this.cancelCode.setMandatory(true);
        return this.cancelCode.rootEl;
    };

    this.createActualCancel = function() {
        this.actualCancel = new Monet.UI.Fields.DateTimeField();
        this.actualCancel.setEntity("ActualCancel");

        this.actualCancel.render();

        this.actualCancel.setTextLabel(Monet.I18n.getResourcesByKey('Greenmile.Stop.Cancel.actualCancel'));
        this.actualCancel.setInputName("actualCancel");
        this.actualCancel.setMandatory(true);

        var date = new Monet.Date.GeneralFunctions();
        this.actualCancel.setDefaultValue( date.getCurrentDateAndTime() );

        this.actualCancel.input.className += " dateTimePicker";

        return this.actualCancel.rootEl;

    };

    this.getLayout = function (data) {
        return new Monet.UI.LayoutGenerator({
            "items": [
                {
                    "tag": "form",
                    "items": [
                        {
                            "items": [
                                {
                                    "attributes": {
                                        "class": "monetInlineAlerContainer"
                                    }
                                },
                                {
                                    "items": [
                                        {
                                            "attributes": {
                                                "class": "popup-modal-header"
                                            },
                                            "items": [
                                                {
                                                    "tag": "h3",
                                                    "html": data.btnSaveValue,
                                                },
                                                {
                                                    "tag": "div",
                                                    "items": [
                                                        {
                                                            "tag": "a",
                                                            "attributes": {
                                                                "href": "https://greenmile.help.descartesservices.com",
                                                                "class": "MonetUIHelpLink",
                                                                "title": "Help"
                                                            },
                                                        }
                                                    ],
                                                    "attributes": {
                                                        "class": "MonetUIHelp"
                                                    },
                                                }
                                            ]
                                        },
                                        {
                                            "tag": "div",
                                            "attributes": {
                                                "class": "popup-modal-body"
                                            },
                                            "items": []
                                        },
                                        {
                                            "tag": "div",
                                            "attributes": {
                                                "class": "popup-modal-footer formButtons"
                                            },
                                            "items": [
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "button",
                                                        "value": data.btnSaveValue,
                                                        "name": "btn_save_cancel_stop",
                                                        "id": "btn_save_cancel_stop",
                                                        "class": "btn",
                                                        "style": "width: 170px"
                                                    }
                                                },
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "button",
                                                        "value": data.btnExitValue,
                                                        "name": "btn_exit_cancel_stop",
                                                        "id": "btn_exit_cancel_stop",
                                                        "class": "btn secondary",
                                                        "style": "width: 75px"
                                                    }
                                                }
                                            ],
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "id": "formDepartStopFormTemplate"
                    }
                }
            ]
        }).render();
    };

    this.createForm = function () {
        const modalContainer = document.querySelector(`${parentSelector} .popupFormContainer`);

        if (modalContainer) {

            modalContainer.appendChild(this.getLayout({
                btnSaveValue: Monet.I18n.getResourcesByKey('Greenmile.Stop.Cancel.btnSave'),
                btnExitValue: Monet.I18n.getResourcesByKey('Greenmile.Stop.Cancel.btnExit')
            }));

            const formContainer = document.querySelector("#formDepartStopFormTemplate .popup-modal-body");
            formContainer.appendChild(this.createCancelCode());
            formContainer.appendChild(this.createActualCancel());

        } else {
            new Monet.Exception.ReturnError(this, "No .popupFormContainer found.")
                .console();
        }

    };

    this.validate = function () {
      const utils = new Greenmile.Route.ModalUtils();
      const scopeMessage = this.selector + ' .popupFormContainer #formDepartStopFormTemplate';

      const cancelTimeMs = Monet.Format.DateTime.parseLocale(
        this.actualCancel.value
      ).getTime();

      const errors = this.cancelCode
        .validate()
        .concat(this.actualCancel.validate());

      if (cancelTimeMs >= new Date().getTime()) {
        utils.showErrorMessage(
          scopeMessage,
          'actualCancel',
          'Stop.Cancel.cantArriveInTheFuture'
        );

        return false;
      }

      if (errors.length) {
        const monetMessage = new Monet.Form.Messages.InlineMessage();

        monetMessage.setScope(this.selector);
        monetMessage.setInfoType('error');

        monetMessage.setMessage({
          errorMessages: errors
        });

        monetMessage.triggerMessage();

        return false;
      }

      return true;
    };

    this.requestCancel = function () {

        const dataToSend = {
            cancelCode: this.cancelCode.getValue(),
            actualCancel: this.actualCancel.getValue()
        };

        if( this.validate() ) {
            this.modalForm.toggleLoadingInModalBtn();

            const ajax = new Monet.Ajax;

            const parsedStopKey = Greenmile.Stop.Util.formatStopKey(this.stop);

            ajax.url = `Route/${this.routeId}/Stop/${parsedStopKey}/Cancel`;
            ajax.method = "POST";
            ajax.data = dataToSend;
            ajax.success = this.successCallback.bind(this);
            ajax.error = this.errorCallback.bind(this);
            ajax.send();

        }

    };

    this.successCallback = function () {
      if (parentSelector === '#RouteSummary') {
        const router = new App.Routers.RouteSummaryStops();

        App.Forms.RouteSummaryStops.pagination.first = 0;
        this.modalForm.closeModalWindow();

        router.updateGrid(router.getFilter(), Monet.Grid.addDataToGrid, false);
      } else {
        this.modalForm.closeModalWindow();
        successCallback?.();
      }
    };

    this.addEventListenners = function () {

        const that = this;

        try {
            const btnSave = document.querySelector("#btn_save_cancel_stop");
            const btnExit = document.querySelector("#btn_exit_cancel_stop");

            btnExit.onclick = function () {
                that.modalForm.closeModalWindow();
            };

            btnSave.onclick = function () {
                that.requestCancel();
            };

        } catch (e) {
            new Monet.Exception.ReturnError(this, "No add event listenner to form.")
                .console();

        }

    };
    this.errorCallback = function () {
        this.modalForm.toggleLoadingInModalBtn();
    };

    this.createAllStructure = function () {
        this.prepareToCreateForm();
        this.createForm();
        this.addEventListenners();
    };

    this.selector = parentSelector;
    this.scopeBlock = ".mainContainer";

    this.modalForm = new Monet.Form.Modal(this.selector, {
        width: 280,
        height: 250
    }, {
        onAfterShowModalForm: this.createAllStructure.bind(this)
    }, this.scopeBlock);

};
